import { render, staticRenderFns } from "./UsersPrivilegeMeasurements.vue?vue&type=template&id=7af56bb8&scoped=true&"
import script from "./UsersPrivilegeMeasurements.vue?vue&type=script&lang=js&"
export * from "./UsersPrivilegeMeasurements.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7af56bb8",
  null
  
)

export default component.exports